import styled from 'styled-components'

import Back from '../../assets/images/back.svg'

export const BackIcon = styled(Back).attrs({ width: '14px', height: '14px' })`
    min-width: 0.875rem;
    min-height: 0.875rem;
`
